import React from 'react';
import { FaFolder, FaTag } from 'react-icons/fa';
import {
  TagsContainer,
  TagOption,
  TagIcon,
  TagCount
} from './styles';

const TagTreeOption = ({ tag, level = 0, selectedTags, onToggle }) => {
  const hasChildren = tag.children && tag.children.length > 0;
  const isSelected = selectedTags.some(t => t.id === tag.id);

  return (
    <div>
      <TagOption
        selected={isSelected}
        onClick={() => onToggle(tag)}
        type="button"
        style={{ marginLeft: `${level * 20}px` }}
      >
        <TagIcon>
          {hasChildren ? <FaFolder /> : <FaTag />}
        </TagIcon>
        {tag.name}
        {hasChildren && <TagCount>({tag.children.length})</TagCount>}
      </TagOption>
      
      {hasChildren && tag.children.map(child => (
        <TagTreeOption
          key={child.id}
          tag={child}
          level={level + 1}
          selectedTags={selectedTags}
          onToggle={onToggle}
        />
      ))}
    </div>
  );
};

const TagSelector = ({ tags, selectedTags, onTagToggle }) => {
  return (
    <TagsContainer>
      {tags.map(tag => (
        <TagTreeOption
          key={tag.id}
          tag={tag}
          selectedTags={selectedTags}
          onToggle={onTagToggle}
        />
      ))}
    </TagsContainer>
  );
};

export default TagSelector; 